import React from 'react'
// import MediaQuery from "react-responsive"

// Hook
// const switchingWidth = 767
// const Sp = ({children, width = switchingWidth}) => {
//     return(
//         <MediaQuery query={`(max-width: ${width}px)`}>
//             {children}
//         </MediaQuery>
//     )
// }
// const Pc = ({children, width = switchingWidth}) => {
//     return(
//         <MediaQuery query={`(min-width: ${width}px)`}>
//             {children}
//         </MediaQuery>
//     )
// }

const Sp = ({children}) => {
    return(
        <div className="sp">
            {children}
        </div>
    )
}
const Pc = ({children}) => {
    return(
        <div className="pc">
            {children}
        </div>
    )
}

export { Pc, Sp }